// ISO 27001 room keys. Generic project room code does not list these; this standard owns them.
// Mirror of isoplanner-api Iso27001Rooms.

export const Iso27001Rooms = {
  Profile: 'profile',
  Scope: 'scope',
  Objectives: 'objectives',
  Risks: 'risks',
  Roles: 'roles',
  Documents: 'documents',
  // The rooms of the information-assets milestone (Kickstart step 1). Asset inquiry has its room
  // component; an unregistered key renders `ProjectRoomPlaceholder`. Asset answers holds each
  // responsible person's list; the inquiry task's window reads and writes it.
  AssetInquiry: 'asset-inquiry',
  AssetAnswers: 'asset-answers',
  InquiryProgress: 'inquiry-progress',
  AssetRegister: 'asset-register',
  // The Uitvraag uitkomsten: whoever manages the project sends it per role; outcome answers holds each role's list of
  // outcomes per document, its document choices and its ownership row, which the inquiry task's window reads and writes.
  OutcomeInquiry: 'outcome-inquiry',
  OutcomeAnswers: 'outcome-answers',
  // The external audit: its own page (ProjectExternalAuditRoom) instead of the room frame.
  ExternalAudit: 'arrange-external-audit',
} as const;
